import { styled } from '@mui/material';

export const Container = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

export const Content = styled('div')({
  width: '500px',
});
